import { IconButton, Tooltip } from '@mui/material'
import { ErrorOutline, PlayArrow, Stop } from '@mui/icons-material'

/** Play/stop for one preview clip, driven by usePreviewAudio. Renders nothing without a URL. */
export function PreviewButton({
  url,
  playing,
  failed,
  onToggle,
  label,
}: {
  url: string | null | undefined
  playing: string | null
  failed: string | null
  onToggle: (url: string) => void
  label: string
}) {
  if (!url) return null
  const isPlaying = playing === url
  const isFailed = failed === url
  return (
    <Tooltip title={isFailed ? "The preview couldn't be played" : isPlaying ? 'Stop' : 'Play preview'}>
      <IconButton
        size="small"
        aria-label={`${isPlaying ? 'Stop' : 'Play'} preview of ${label}`}
        color={isFailed ? 'error' : isPlaying ? 'primary' : 'default'}
        onClick={(e) => {
          e.stopPropagation()
          onToggle(url)
        }}
      >
        {isFailed ? <ErrorOutline fontSize="small" /> : isPlaying ? <Stop fontSize="small" /> : <PlayArrow fontSize="small" />}
      </IconButton>
    </Tooltip>
  )
}
